// extracted by mini-css-extract-plugin
module.exports = {"Anchor":"Anchor__2S5BO","Anchor_id":"Anchor_id__2S5BO"};